import { render, staticRenderFns } from "./CatalogListEntry.vue?vue&type=template&id=59524312&"
import script from "./CatalogListEntry.vue?vue&type=script&lang=js&"
export * from "./CatalogListEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports